import { get, merge } from 'lodash';
import { ACClient as ACBaseClient } from 'vue-infra';

import BaseClient from '../common/BaseClient';
import ApiResources from '../data/apiResources';
import { SOURCE_APP_NAME } from '../common/consts';

const RESOURCES = {
  USERS: 'users',
  USER_SITE_SETTINGS: 'userSiteSettings',
  WORKATO_SITE_SETTINGS: 'workatoSiteSettings',
  SKILLS: 'skills',
  WIDGETS: 'widgets',
  MEDALLIA_SITE_SETTINGS: 'medalliaSiteSettings',
};

const RESOURCES_CONFIGURATION = {
  [RESOURCES.USERS]: {
    ALLOWED_METHODS: [BaseClient.HTTP_METHODS.GET, BaseClient.HTTP_METHODS.PUT, BaseClient.HTTP_METHODS.POST],
    URL_KEY: () => 'AC.Users',
  },
  [RESOURCES.WORKATO_SITE_SETTINGS]: {
    ALLOWED_METHODS: [BaseClient.HTTP_METHODS.GET, BaseClient.HTTP_METHODS.PUT, BaseClient.HTTP_METHODS.POST],
    URL_KEY: () => 'AC.WorkatoSiteSettings',
  },
  [RESOURCES.SKILLS]: {
    ALLOWED_METHODS: [BaseClient.HTTP_METHODS.GET, BaseClient.HTTP_METHODS.PUT, BaseClient.HTTP_METHODS.POST],
    URL_KEY: () => 'AC.Skills',
  },
  [RESOURCES.WIDGETS]: {
    ALLOWED_METHODS: [BaseClient.HTTP_METHODS.GET, BaseClient.HTTP_METHODS.PATCH, BaseClient.HTTP_METHODS.PUT, BaseClient.HTTP_METHODS.POST],
    URL_KEY: () => 'AC.Widgets',
  },
  [RESOURCES.MEDALLIA_SITE_SETTINGS]: {
    ALLOWED_METHODS: [BaseClient.HTTP_METHODS.GET, BaseClient.HTTP_METHODS.PUT, BaseClient.HTTP_METHODS.POST],
    URL_KEY: () => 'AC.MedalliaSiteSettings',
  },
  [RESOURCES.USER_SITE_SETTINGS]: {
    ALLOWED_METHODS: [BaseClient.HTTP_METHODS.GET, BaseClient.HTTP_METHODS.PUT, BaseClient.HTTP_METHODS.POST],
    URL_KEY: () => 'AC.SiteSettings',
  },
};

class ACClient extends BaseClient {
  constructor({
    resource,
    contextName,
    ...options
  }) {
    const infraBaseClient = createACBaseClient(options, resource, contextName);
    super({
      name: 'ACClient',
      client: infraBaseClient,
      ...options,
    });
  }
}

function createACBaseClient(options, resource, contextName) {
  // TODO: need to implement out own urlResolver
  const urlResolver = window.LE.urlResolver;
  const objFromApiResources = get(ApiResources, RESOURCES_CONFIGURATION[resource].URL_KEY());

  const fullUrl = urlResolver.getUrl(objFromApiResources);
  const url = urlResolver.getUrlParts(fullUrl);
  const path = `${url.pathname}${url.search}${url.hash}`;

  const params = objFromApiResources ? objFromApiResources.params : {};

  const acBaseClientOptions = {
    allowedMethods: RESOURCES_CONFIGURATION[resource].ALLOWED_METHODS,
    path,
    source: {
      appName: SOURCE_APP_NAME,
      contextName,
    },
    config: {
      timeout: RESOURCES_CONFIGURATION[resource].TIMEOUT,
      params,
    },
  };
  merge(acBaseClientOptions, options);
  const acClient = new ACBaseClient(acBaseClientOptions);
  return acClient;
}

ACClient.RESOURCES = RESOURCES;

export default ACClient;
